import React from 'react'
import styled from 'styled-components'
import Header from '../../components/common/Header'
import Footer from '../../components/common/Footer'
import ForgetPW from '../../components/User/ForgetPW'

const ForgetPWPage = () => {
  return (
    <>
        <Header/>
        <Container>
            <ForgetPW/>
        </Container>
        <Footer />
    </>
  )
}

export default ForgetPWPage

const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
`